import React from 'react';
import { Link } from '@/Framework/Router/Next/Link';
import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';

interface ICell {
  tooltip: React.ReactNode,
  href: string,
  content: React.ReactNode,
  className?: string,
}

const Cell = ({
  className = '',
  tooltip,
  content,
  href = '',
}: ICell) => (
  <Tooltip
    content={ tooltip }
    containerClassName={ className }
  >
    { href ? <Link to={ href }>{ content }</Link> : content }
  </Tooltip>
);

export default Cell;
